export const SIGN_UP_BEGIN = "SIGN_UP_BEGIN";
export const signUpBegin = (
  email,
  password,
  securityQuestion,
  securityAnswer
) => ({
  type: SIGN_UP_BEGIN,
  email,
  password,
  securityQuestion,
  securityAnswer,
});

export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const signUpSuccess = () => ({
  type: SIGN_UP_SUCCESS,
});

export const SIGN_UP_FAILED = "SIGN_UP_FAILED";
export const signUpFailed = () => ({
  type: SIGN_UP_FAILED,
});
